export default "/assets/images/award-img-02.png?d88f6cde9b136d1620d7c32aad8075f1";